import { SUPPORTED_CHANNELS } from './constants';
import type { OnlineShareAction, SupportedChannel } from './types';

// Type guard for SupportedChannel to only allow specific channels
export function isSupportedChannelAction(
	action: OnlineShareAction,
): action is OnlineShareAction & { channel: SupportedChannel } {
	return isSupportedChannel(action.channel);
}

export function isSupportedChannel(channel: string): channel is SupportedChannel {
	return SUPPORTED_CHANNELS.includes(channel);
}
